import * as React from 'react';
import { useEffect, useRef, useState, useCallback } from 'react';
import { logger } from '../Utils/logger';

export function useCountdownSeconds(durationInSeconds: number, onStart?: () => void, paused: boolean = false) {
  const timeout = useRef<ReturnType<typeof setInterval> | undefined>(undefined);
  const onStartRef = useRef(onStart);
  const pausedRef = useRef(paused);

  // Keep refs up to date without causing re-renders
  useEffect(() => {
    onStartRef.current = onStart;
  }, [onStart]);

  useEffect(() => {
    pausedRef.current = paused;
  }, [paused]);

  const [countdown, setCountdown] = useState(durationInSeconds);

  useEffect(() => {
    timeout.current = setInterval(() => {
      if (!pausedRef.current) {
        setCountdown((prev) => Math.max(0, prev - 1));
      }
    }, 1000);
    return () => {
      logger('dispose timeout');
      timeout.current && clearInterval(timeout.current);
      timeout.current = undefined;
    };
  }, [durationInSeconds]); // Removed paused - using ref instead

  useEffect(() => {
    if (countdown <= 0) {
      timeout.current && clearInterval(timeout.current);
      timeout.current = undefined;
      onStartRef.current?.();
    }
  }, [countdown]);

  const resetCountdown = useCallback(() => {
    timeout.current && clearInterval(timeout.current);
    timeout.current = undefined;
    setCountdown(durationInSeconds);
    timeout.current = setInterval(() => {
      if (!pausedRef.current) {
        setCountdown((prev) => Math.max(0, prev - 1));
      }
    }, 1000);
  }, [durationInSeconds]); // Removed paused - using ref instead

  return { countdown, resetCountdown };
}
